import type { ReactNode } from 'react';

export const symbol_cleaning: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M418-785v-35h-28q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h215q16 0 25.5 9.5T640-845v33q0 4.17-.5 7.08Q639-802 637-799l-37 74H493v-45l-79.93 84.87Q412-684 397-680q-8.57 0-13.29-7-4.71-7-.71-15l35-83ZM380-80q-24.75 0-42.37-17.63Q320-115.25 320-140v-218q0-7.63 1.78-14.88 1.78-7.25 6.22-14.12l148-267q8.06-14.42 21.61-22.71Q511.15-685 528-685h82q12.75 0 21.38 8.62Q640-667.75 640-655v515q0 24.75-17.62 42.37Q604.75-80 580-80H380Zm0-60h200v-485h-52L380-358v218Zm0 0h200-200Z"
		/>
	</svg>
);
